import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pointCardData: {},
  pageFlag: 'create'
}

export const pointCardSlice = createSlice({
  name: 'pointCard',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setPointCardDataAction: (state, action) => {
      state.pointCardData = action.payload
    },
    setPointCardPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setPointCardDataAction, setPointCardPageFlagAction } = pointCardSlice.actions

// Selectors
export const selectPointCardData = (state) => state.pointCard.pointCardData
export const selectPointCardPageFlag = (state) => state.pointCard.pageFlag

// Reducer
export default pointCardSlice.reducer